const dotdMenu = function () {
	//todo on resize, hide the menu if window width is less than 600 px
	
	const mobileBtn = document.getElementById("menu-button");
	const menuItems = document.querySelector(".headerMenuBar");
	
	const init = () => {
		// Add a handler function for the resize event of window
		getMenuGreeting();
		mobileBtn.addEventListener('click', toggleMenu);
		window.addEventListener('appinstalled', adobeLogAppInstall);
	},
	getMenuGreeting = () => {
		fetch('/dealoftheday/account/MenuGreeting', {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
		}).then(function (response) {
			return (response.ok) ? response.text() : []; // response.json() returns a promise
		}).then(function (response) {
			document.getElementById("headerGreeting").innerHTML = response;// proceed after successful request
		});
	},
	toggleMenu = (e) => {
		e.preventDefault();
		
		if (mobileBtn.getAttribute("aria-expanded") == "true") closeMenu();
		else openMenu();
	},
	openMenu = () => {
		mobileBtn.setAttribute("aria-expanded", "true");
		menuItems.classList.remove("hideOnSmall");
		//todo close on escape
	},
	closeMenu = () => {
		mobileBtn.setAttribute("aria-expanded", "false");
		menuItems.classList.add("hideOnSmall");
	},
	adobeLogAppInstall = () => {
		var s = typeof s_gi === 'function' ? s_gi(s_account) : '';
		if (s) {
			s.events = 'event11';
			s.t();
		}
	};

	return {
		Init: init
	};
};

(function () {
	const menu = new dotdMenu();
	menu.Init();
})();